module.exports = __webpack_public_path__ + "static/Pimloc-f5057038b024f8843ec55eee51076abb.jpg";